<template>
  <div :class="containerClass" :data-id="containerId" data-element_type="container"
    data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">

    <!-- Recommended Badge (for Stoic account only) -->
    <div v-if="recommended" class="elementor-element elementor-element-2f80dace e-flex e-con-boxed e-con e-child"
      data-id="2f80dace" data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-40b025d7 elementor-widget elementor-widget-heading"
          data-id="40b025d7" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">RECOMMENDED</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Account Header -->
    <div :class="headerContainerClass" :data-id="headerContainerId" data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
      <div class="e-con-inner">
        <div :class="iconClass" :data-id="iconId" data-element_type="widget" data-widget_type="icon.default">
          <div class="elementor-widget-container">
            <div class="elementor-icon-wrapper">
              <div class="elementor-icon">
                <svg width="400" height="400">
                  <use :href="`/assets/svg/sprite.svg#${iconSvgId}`"></use>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div :class="titleClass" :data-id="titleId" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">{{ accountName }}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Account Pricing -->
    <div class="elementor-element elementor-element-554a6021 e-flex e-con-boxed e-con e-child"
      data-id="554a6021" data-element_type="container"
      data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-57e74d5b e-grid e-con-boxed e-con e-child"
          data-id="57e74d5b" data-element_type="container"
          data-settings="{&quot;container_type&quot;:&quot;grid&quot;,&quot;grid_columns_grid&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:2,&quot;sizes&quot;:[]},&quot;grid_columns_grid_mobile&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:2,&quot;sizes&quot;:[]},&quot;grid_rows_grid&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:1,&quot;sizes&quot;:[]},&quot;grid_rows_grid_mobile&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:1,&quot;sizes&quot;:[]},&quot;content_width&quot;:&quot;boxed&quot;,&quot;grid_outline&quot;:&quot;yes&quot;,&quot;grid_columns_grid_tablet&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;grid_rows_grid_tablet&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;grid_auto_flow&quot;:&quot;row&quot;,&quot;grid_auto_flow_tablet&quot;:&quot;row&quot;,&quot;grid_auto_flow_mobile&quot;:&quot;row&quot;}">
          <div class="e-con-inner">
            <!-- Spread From -->
            <div class="elementor-element elementor-element-4c032e0f e-flex e-con-boxed e-con e-child"
              data-id="4c032e0f" data-element_type="container"
              data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
              <div class="e-con-inner">
                <div class="elementor-element elementor-element-3c4da0c4 e-flex e-con-boxed e-con e-child"
                  data-id="3c4da0c4" data-element_type="container"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
                  <div class="e-con-inner">
                    <div class="elementor-element elementor-element-29fc0e63 elementor-widget elementor-widget-heading"
                      data-id="29fc0e63" data-element_type="widget" data-widget_type="heading.default">
                      <div class="elementor-widget-container">
                        <h2 class="elementor-heading-title elementor-size-default">Spread From</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-31d773d3 elementor-widget elementor-widget-heading"
                  data-id="31d773d3" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ spread }}</h2>
                  </div>
                </div>
              </div>
            </div>

            <!-- Commission -->
            <div class="elementor-element elementor-element-1a9f617f e-flex e-con-boxed e-con e-child"
              data-id="1a9f617f" data-element_type="container"
              data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
              <div class="e-con-inner">
                <div class="elementor-element elementor-element-22fe0503 e-flex e-con-boxed e-con e-child"
                  data-id="22fe0503" data-element_type="container"
                  data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
                  <div class="e-con-inner">
                    <div class="elementor-element elementor-element-7364ea33 elementor-widget elementor-widget-heading"
                      data-id="7364ea33" data-element_type="widget" data-widget_type="heading.default">
                      <div class="elementor-widget-container">
                        <h2 class="elementor-heading-title elementor-size-default">Commision</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-3a2075ea elementor-widget elementor-widget-heading"
                  data-id="3a2075ea" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">{{ commission }}</h2>
                  </div>
                </div>
                <div class="elementor-element elementor-element-48c1f39d elementor-widget elementor-widget-text-editor"
                  data-id="48c1f39d" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container">
                    <p>(Per lot per side)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Features -->
    <div class="elementor-element elementor-element-1028ec21 e-flex e-con-boxed e-con e-child"
      data-id="1028ec21" data-element_type="container"
      data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-5b7d2dfb elementor-widget elementor-widget-heading"
          data-id="5b7d2dfb" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Feature:</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Features Grid -->
    <div class="elementor-element elementor-element-72cfe739 e-grid e-con-boxed e-con e-child"
      data-id="72cfe739" data-element_type="container"
      data-settings="{&quot;container_type&quot;:&quot;grid&quot;,&quot;grid_columns_grid&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:2,&quot;sizes&quot;:[]},&quot;grid_columns_grid_tablet&quot;:{&quot;unit&quot;:&quot;custom&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;grid_columns_grid_mobile&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:2,&quot;sizes&quot;:[]},&quot;grid_rows_grid&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:1,&quot;sizes&quot;:[]},&quot;content_width&quot;:&quot;boxed&quot;,&quot;grid_outline&quot;:&quot;yes&quot;,&quot;grid_rows_grid_tablet&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;grid_rows_grid_mobile&quot;:{&quot;unit&quot;:&quot;fr&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;grid_auto_flow&quot;:&quot;row&quot;,&quot;grid_auto_flow_tablet&quot;:&quot;row&quot;,&quot;grid_auto_flow_mobile&quot;:&quot;row&quot;}">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-6fce59a4 elementor-widget elementor-widget-heading"
          data-id="6fce59a4" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">
              <!-- Minimum Deposit <br> -->
              Minimum Trade<br>Leverage Max<br>SWAP
            </h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-790d526b elementor-widget elementor-widget-heading"
          data-id="790d526b" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">
              <!-- {{ minDeposit }}<br> -->
              {{ minTrade }}<br>{{ leverage }}<br>{{ swap }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Info and CTA -->
    <div class="elementor-element elementor-element-507c3e6b e-flex e-con-boxed e-con e-child"
      data-id="507c3e6b" data-element_type="container"
      data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
      <div class="e-con-inner">
        <div v-if="swapNote" class="elementor-element elementor-element-912c681 elementor-widget elementor-widget-text-editor"
          data-id="912c681" data-element_type="widget" data-widget_type="text-editor.default">
          <div class="elementor-widget-container">
            <p>{{ swapNote }}</p>
          </div>
        </div>
        <div class="elementor-element elementor-element-7149fc54 elementor-widget elementor-widget-heading"
          data-id="7149fc54" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Suitable For:</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-13458593 elementor-widget elementor-widget-heading"
          data-id="13458593" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">{{ suitableFor }}</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-609f952 elementor-align-justify elementor-widget elementor-widget-button"
          data-id="609f952" data-element_type="widget" data-widget_type="button.default">
          <div class="elementor-widget-container">
            <div class="elementor-button-wrapper">
              <router-link class="elementor-button elementor-button-link elementor-size-sm"
                to="/signup">
                <span class="elementor-button-content-wrapper">
                  <span class="elementor-button-text">Get Account</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountCard',
  props: {
    accountType: {
      type: String,
      required: true,
      validator: value => ['philosopher', 'stoic', 'pamm'].includes(value)
    },
    accountName: {
      type: String,
      required: true
    },
    iconSvgId: {
      type: String,
      required: true
    },
    spread: {
      type: String,
      required: true
    },
    commission: {
      type: String,
      required: true
    },
    minDeposit: {
      type: String,
      required: true
    },
    minTrade: {
      type: String,
      default: '0.01'
    },
    leverage: {
      type: String,
      default: '1:25'
    },
    swap: {
      type: String,
      default: '*Free'
    },
    // swapNote: {
    //   type: String,
    //   default: '(*Free SWAP for Minimum Deposit $1.000)'
    // },
    suitableFor: {
      type: String,
      required: true
    },
    recommended: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerClass() {
      const baseClass = 'elementor-element e-con-full e-flex e-con e-child'
      const typeClass = {
        'philosopher': 'elementor-element-24532d1c',
        'stoic': 'elementor-element-226ce50f',
        'pamm': 'elementor-element-61915b65'
      }
      return `${baseClass} ${typeClass[this.accountType]}`
    },
    containerId() {
      const ids = {
        'philosopher': '24532d1c',
        'stoic': '226ce50f',
        'pamm': '61915b65'
      }
      return ids[this.accountType]
    },
    headerContainerClass() {
      const baseClass = 'elementor-element e-flex e-con-boxed e-con e-child'
      const typeClass = {
        'philosopher': 'elementor-element-ef71a97',
        'stoic': 'elementor-element-50c24dff',
        'pamm': 'elementor-element-1fe50f9f'
      }
      return `${baseClass} ${typeClass[this.accountType]}`
    },
    headerContainerId() {
      const ids = {
        'philosopher': 'ef71a97',
        'stoic': '50c24dff',
        'pamm': '1fe50f9f'
      }
      return ids[this.accountType]
    },
    iconClass() {
      const baseClass = 'elementor-element elementor-view-default elementor-widget elementor-widget-icon'
      const typeClass = {
        'philosopher': 'elementor-element-53620ce5',
        'stoic': 'elementor-element-27ead47f',
        'pamm': 'elementor-element-5df33bc4'
      }
      return `${baseClass} ${typeClass[this.accountType]}`
    },
    iconId() {
      const ids = {
        'philosopher': '53620ce5',
        'stoic': '27ead47f',
        'pamm': '5df33bc4'
      }
      return ids[this.accountType]
    },
    titleClass() {
      const baseClass = 'elementor-element elementor-widget elementor-widget-heading'
      const typeClass = {
        'philosopher': 'elementor-element-47b68234',
        'stoic': 'elementor-element-77954133',
        'pamm': 'elementor-element-2343ba9d'
      }
      return `${baseClass} ${typeClass[this.accountType]}`
    },
    titleId() {
      const ids = {
        'philosopher': '47b68234',
        'stoic': '77954133',
        'pamm': '2343ba9d'
      }
      return ids[this.accountType]
    }
  }
}
</script>
